/**
 * Slice a single availability gap into back-to-back `duration`-sized
 * slots. Stops when the next slot would overflow the gap end. Each
 * slot id is the `gen-{dateKey}-{startMs}` tuple so removal can later
 * target exactly one slot regardless of re-renders.
 */
import moment from 'moment-timezone';
import type { SelfSlot } from '../types';

interface SliceArgs {
  /** ms epoch — already rounded/buffered by earlier stages. */
  startMs: number;
  /** ms epoch — end of the usable gap. */
  endMs: number;
  durationMinutes: number;
  timezone: string;
  dateKey: string;
}

export function sliceInterval({
  startMs,
  endMs,
  durationMinutes,
  timezone,
  dateKey,
}: SliceArgs): SelfSlot[] {
  if (durationMinutes <= 0) return [];
  const stepMs = durationMinutes * 60_000;
  const out: SelfSlot[] = [];
  let cursor = startMs;
  while (cursor + stepMs <= endMs) {
    out.push({
      id: `gen-${dateKey}-${cursor}`,
      start: moment.tz(cursor, timezone).toISOString(),
      end: moment.tz(cursor + stepMs, timezone).toISOString(),
      dateKey,
      isCustom: false,
    });
    cursor += stepMs;
  }
  return out;
}
